import GoFanImage from 'images/icons/go-fan.png';
import PoweredBy from './PoweredBy';

export default function GoFanPoweredBy() {
  return <PoweredBy image={GoFanImage} />;
}
